module.exports = __webpack_public_path__ + "img/642.a3d79b02.jpg";